
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningSilencedIec as ObiWarningSilencedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-silenced-iec.js';
 
 
 

 
 export const ObiWarningSilencedIec = createComponent({
   react: React,
   tagName: 'obi-warning-silenced-iec',
   elementClass: ObiWarningSilencedIecElement,
   events: {
     
   }
  });
 
 